import React from "react";
import { ArrowRight } from "lucide-react";
import { useBooking } from "@/components/BookingContext";
import { cn } from "@/lib/utils";

// Primary CTA. Every instance reads "Book a Discovery Call." and opens the calendar modal.
export function BookButton({ className, variant = "solid", testid = "book-a-call", label = "Book a Discovery Call" }) {
    const { open } = useBooking();

    const base =
        "group inline-flex items-center gap-2.5 font-medium rounded-full transition-colors duration-300 select-none";

    const styles =
        variant === "solid"
            ? "bg-primary text-primary-foreground px-6 py-3 text-[0.95rem] hover:bg-foreground/85"
            : variant === "ghost"
            ? "text-foreground px-2 py-1.5 text-sm hover:text-muted-foreground"
            : "border border-foreground/25 text-foreground px-6 py-3 text-[0.95rem] hover:bg-foreground hover:text-primary-foreground";

    return (
        <button data-testid={testid} onClick={open} className={cn(base, styles, className)}>
            <span>{label}</span>
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
        </button>
    );
}
